import Provider from "./provider";
export * from "./provider";
export default Provider;
//# sourceMappingURL=index.js.map